<template>
  <div v-bind:id="chartId" class="chart"></div>
</template>
<script>
export default {
  name: 'stackBarChart',
  data () {
    return {
      chart: null,
      basisOption: {
        title: {
          text: '',
          textStyle: {
            fontSize: '14',
            fontWeight: '500'
          },
          left: 'center' // title 组件离容器左侧的距离。
        },
        legend: {
          top: '30'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          // 网格
          left: '60',
          right: '40',
          bottom: '30',
          containLabel: false
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisTick: {
              show: true,
              alignWithLabel: true // 刻度线
            },
            axisLabel: {
              show: true
              // interval: 0 // 横坐标是否都显示
            }
          }
        ],
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0],
            minValueSpan: 0,
            maxValueSpan: 9
          },
          {
            type: 'slider',
            xAxisIndex: [0],
            minValueSpan: 0,
            maxValueSpan: 9
          }
        ],
        color: [
          '#334FC5',
          '#ff4c62',
          '#06B0FF',
          '#00CE69',
          '#FF7443',
          '#7A4CF2',
          '#9BCB2A',
          '#65648C',
          '#EF938A',
          '#69D9F0 ',
          '#E1B139',
          '#AB9FDC'
        ]
      }
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    load: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartId () {
      return 'stackBarChart' + Math.random() * 100000
    }
  },
  mounted () {
    setTimeout(() => {
      this.initChart()
    })

    // 自适应
    window.addEventListener('resize', () => {
      this.chartResize()
    })
  },
  activated () {
    this.chartResize()
  },
  watch: {
    option (val) {
      // 将传递来的options与已有的合并
      this.chart.setOption(val)
    },
    load (val) {
      this.setLoading(val)
    },
    clear (val) {
      this.clearChart(val)
    }
  },
  methods: {
    initChart () {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById(this.chartId))
      // 绘制图表
      chart.setOption(this.basisOption)
      // chart.on('click', function (event) {
      //   console.log(event.data.label)
      // })
      this.chart = chart
      this.setLoading(this.load)
    },
    chartResize () {
      this.chart && this.chart.resize()
    },
    setLoading (val = false) {
      if (this.chart) {
        if (val) {
          this.chart.showLoading({
            text: '',
            color: '#409EFF',
            lineWidth: 2,
            textStyle: {
              fontSize: 20
            }
          })
        } else {
          this.chart.hideLoading()
        }
      }
    },
    clearChart (val = false) {
      if (val) {
        this.chart.setOption(this.basisOption, true)// 不跟之前设置的 option 进行合并
      }
    }
  }
}
</script>
<style lang="less" scoped>
.chart {
  height: 480px;
  width: 100%;
}
</style>
